import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from '@/components/molecules/skeletons';
import { PageContainer } from '@/components/templates/PageContainer';

export const AdminPageSkeleton = memo(function AdminPageSkeleton() {
  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <div className="bg-card border border-border rounded-xl shadow-none p-6">
          <Skeleton className="h-48 w-full rounded-lg" />
        </div>
      </div>
    </PageContainer>
  );
});
